import { ClockIcon, XIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';
import { Button } from '../../components/ui/button';
import formatDateTime from './formatTime';

const toastOptions = { position: 'bottom-center', duration: 3000 };

function TestListingNoticeToast({ t, message }) {
  return (
    <div className="bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)] rounded-lg p-4 shadow-lg max-w-md">
      <div className="flex items-start justify-between">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <ClockIcon className="text-[var(--q3-accent-normal)]" />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-[var(--q3-accent-normal)]">{message}</p>
          </div>
        </div>
        <div className="ml-4 flex-shrink-0 cursor-pointer">
          <Button
            variant="outline"
            className="inline-flex !bg-[var(--q3-surface-default)] shadow-none border-none text-[var(--q3-danger-normal)] hover:text-[var(--q3-danger-dark)]"
            onClick={(e) => {
              e.stopPropagation();
              toast.remove(t.id);
            }}
          >
            <span className="sr-only">Close</span>
            <XIcon />
          </Button>
        </div>
      </div>
    </div>
  );
}

export function showUpcomingTestToast(test) {
  toast.custom(
    (t) => (
      <TestListingNoticeToast t={t} message={`${test.title} will be available on ${formatDateTime(test?.startDate)}`} />
    ),
    toastOptions,
  );
}

export function showTestEndedToast(test) {
  toast.custom(
    (t) => <TestListingNoticeToast t={t} message={`${test.title} has ended on ${formatDateTime(test?.endDate)}`} />,
    toastOptions,
  );
}
